<template>
    <div>
        <div class="block-container">
            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>服务信息</span>
                </div>
                <!--                <div class="fr">
                                    <a class="btn-link" @click="relevanceServcOrder()">查看关联订单</a>
                                </div>-->
            </div>
            <div class="form-single" v-if="servcOrder.skuTitle != null">
                <div class="title">服务商品</div>
                <div class="content">
                    <label class="mr20">{{servcOrder.skuTitle}}</label>
                </div>
            </div>
            <div class="form-single" v-if="servcOrder.reqVoucherId != null && servcOrder.reqVoucherId != -1">
                <div class="title">商品是否在保期</div>
                <!--<div class="title" v-else>服务是否在保期</div>-->
                <div class="content">
                    <label class="mr20" v-if="!servcOrder.beyondWrnt">是</label>
                    <label class="mr20" v-if="servcOrder.beyondWrnt">否</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title required">紧急状态</div>
                <div class="content">
                    <el-select placeholder="请选择" class="fl" v-model="servcWorkVoucher.emgLevel" :clearable=true>
                        <el-option v-for="emgLevel in emgLevelList" :key="emgLevel.value" :label="emgLevel.text" :value="emgLevel.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-single">
                <div class="title">服务名称</div>
                <div class="content">
                    <!--<el-checkbox-group v-model="servcItemList">
                        <el-checkbox v-for="(servcOrderItem, index) in servcWorkVoucher.servcOrderItemList" v-bind:disabled="servcOrderItem.isExists" :label="servcOrderItem">
                            {{servcOrderItem.title}}
                        </el-checkbox>
                    </el-checkbox-group>-->
                    <el-radio-group v-model="servcItem">
                        <el-radio v-for="(servcOrderItem, index) in servcOrder.itemList" v-bind:disabled="servcOrderItem.isExists" :label="servcOrderItem">
                            <span>{{servcOrderItem.title}}</span>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-single">
                <div class="title">故障描述</div>
                <div class="content">
                    <label class="mr20" v-if="servcOrder.troubleDesc != null">{{servcOrder.troubleDesc}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">预约上门时间</div>
                <div class="content">
                    <label class="mr20">
                        <span>{{servcOrder.planTime}}</span>
                        <!--<el-date-picker v-model="servcWorkVoucher.planDate" type="date" placeholder="选择日期"></el-date-picker>
                        <el-time-picker is-range v-model="planTimeFromAndTo" placeholder="选择时间范围"></el-time-picker>
                        <el-date-picker v-model="servcWorkVoucher.toDoorTime" type="datetime" placeholder="选择日期时间"></el-date-picker>-->
                    </label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系人</div>
                <div class="content">
                    <label class="mr20" v-if="servcOrder.retailerCom != null">{{servcOrder.retailerCom.contactName}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">联系电话</div>
                <div class="content">
                    <label class="mr20">{{servcOrder.buyerShopContactTel}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">请求服务地址</div>
                <div class="content">
                    <label class="mr20">{{servcOrder.buyerShopAddr}}</label>
                </div>
            </div>
            <!--<div class="form-single">
                <div class="title">备注</div>
                <div class="content">
                    <label class="mr20">
                        <el-input class="width-2x" type="textarea" v-model="textarea"></el-input>
                    </label>
                </div>
            </div>-->
            <div class="content-caption bg-white dashed">
                <span>选择工程师</span>
            </div>
            <div class="form-single">
                <div class="title">请选择工程师</div>
                <div class="content">
                    <div>
                        <span v-for="(engineer, index) in servcWorkVoucherStaffList">
                            {{engineer.engineerName}}
                            <el-radio :label="engineer.engineerId" v-model="checkValue">是否主工程师&nbsp;&nbsp;</el-radio>
                            <a class="font14 swb-btn-link" @click="removeEngineer(index)">移除</a>
                        </span>
                    </div>
                    <label class="mr20">
                        <a class="swb-btn-link" @click="engineerSelect">+ 选择工程师</a>
                    </label>
                </div>
            </div>
            <div class="form-toolbar">
                <button class="swb-btn mr20" @click="saveWorkVoucher">新建并派遣</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'
    import servcOrderApi from '../../api/servcOrder'

    import SwbServicerEngineerListForSelect from '../orgStruct/ServicerEngineerListForSelect';
    Vue.regist(SwbServicerEngineerListForSelect);

    export default {
        name: 'swb-servc-work-voucher-add',
        path: '/servc/work/voucher/add',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '服务派工单保存(门店派工)',
        props: ['orderId'],
        data: function () {
            return {
                servcItem: {},
                servcWorkVoucherStaffList: [],
                emgLevelList: getEnumList("emgLevel", 'value2text'),
                servcOrder: {},
                servcWorkVoucher: {
                    planTime: null,
                    emgLevel: ''
                },
                checkValue: ''
            }
        },
        created: function () {
            let self = this;
//            let servcOrderId = this.$route.query.servcOrderId || null;
            let postData = {};
            let servcOrderId = self.orderId;
            if(!Utils.isNoB(servcOrderId)) {
                postData.servcOrderId = servcOrderId;
            }
            this.getServcOrder(postData);
        },
        methods: {
            getServcOrder: function (postData) {
                let self = this;
                servcOrderApi.getServcOrderDetailedInfo(postData, function (result) {
                    if(result.type === "info") {
                        self.servcOrder = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //查看关联服务订单
            /*relevanceServcOrder: function () {

             },*/
            //选择工程师
            engineerSelect: function () {
                let self = this;
                let ssuIdList = [];
                let servcOrderItemInfo = self.servcItem;
                if(!Utils.isNoB(servcOrderItemInfo) && servcOrderItemInfo.id > 0) {
                    ssuIdList.push(servcOrderItemInfo.ssuId);
                    /*for(let i = 0; i < servcOrderItemList.length; i++) {
                     ssuIdList[i] = servcOrderItemList[i].ssuId;
                     }*/
                    Vue.$showDialog({
                        title: '服务工程师 - 选择',
                        showCloseBtn: true,
                        width: '50%',
                        height: 500,
                        template: '<div>' +
                        '<swb-servicer-engineer-list-for-select :ssuIdList="ssuIdList" :servicerShopId="servicerShopId" :servcCatId="servcCatId" :servcId="servcId" :servcType="servcType" :retailerShopId="retailerShopId" ref="swb_servicer_engineer_list_select"></swb-servicer-engineer-list-for-select>' +
                        '</div>',
                        data: {
                            ssuIdList: [],
                            servicerShopId: self.servcOrder.servicerShopId,
                            servcCatId: servcOrderItemInfo.catId,
                            servcId: self.servcItem.servcId,
                            servcType: self.servcItem.servcType,
                            retailerShopId: self.servcOrder.buyerShopId
                        },
                        methods: {},
                        okClicked: function () {
                            let selfDlg = this;
                            let result = selfDlg.$refs.swb_servicer_engineer_list_select.getDlgResult() || {};
                            if(result != null && result.type === 'info') {
                                let engineerList = result.data;
                                self.servcWorkVoucherStaffList = [];
                                if(!Utils.isNoB(engineerList) && engineerList.length > 0) {
                                    for(let i = 0; i < engineerList.length; i++) {
                                        let engineer = engineerList[i];
                                        let servcWorkVoucherStaff = {};
                                        servcWorkVoucherStaff.engineerId = engineer.id;
                                        servcWorkVoucherStaff.engineerName = engineer.name;
                                        self.servcWorkVoucherStaffList.push(servcWorkVoucherStaff);
                                    }
                                }
                                let servcWorkVoucherStaffList = self.servcWorkVoucherStaffList;
                                if(!Utils.isNoB(servcWorkVoucherStaffList)) {
                                    let servcOrderItemList = self.servcOrder.itemList;
                                    for(let i = 0; i < servcOrderItemList.length; i++) {
                                        let servcOrderItem = servcOrderItemList[i];
                                        if(servcOrderItem.id != servcOrderItemInfo.id) {
                                            servcOrderItem.isExists = true;
                                        }
                                    }
                                    /*for(let i = 0; i < servcOrderItemList.length; i++) {
                                     let servcOrderItem = servcOrderItemList[i];
                                     servcOrderItem.isExists = true;
                                     }*/
                                }
                                return true;
                            } else {
                                MsgBox.warning(result.message);
                            }
                            return false;
                        },
                        lifecycle: {
                            created: function () {
                                this.ssuIdList = ssuIdList;
                            }
                        }
                    });
                } else {
                    MsgBox.warning("请选择要生成派工单的服务！");
                }
            },
            // 移除工程师
            removeEngineer: function (index) {
                let servcWorkVoucherStaffList = this.servcWorkVoucherStaffList || []
                //
                servcWorkVoucherStaffList.splice(index, 1);
            },
            //新建派工单
            saveWorkVoucher: function () {
                let self = this;
                //
                if(Utils.isNoB(self.servcWorkVoucher.emgLevel)) {
                    MsgBox.warning("请选择紧急状态");
                    return;
                }
                if(!Utils.isNoB(self.checkValue)) {
                    //
                    self.servcWorkVoucher.reqVoucherId = self.servcOrder.reqVoucherId;
                    self.servcWorkVoucher.orderId = self.servcOrder.id;
                    self.servcWorkVoucher.orderItemId = self.servcItem.id;
                    // 服务工单人员
                    let servcWorkVoucherStaffList = self.servcWorkVoucherStaffList;
                    for(let i = 0; i < servcWorkVoucherStaffList.length; i++) {
                        let servcWorkVoucherStaff = servcWorkVoucherStaffList[i];
                        if(self.checkValue == servcWorkVoucherStaff.engineerId) {
                            servcWorkVoucherStaff.chiefFlag = true;
                        } else {
                            servcWorkVoucherStaff.chiefFlag = false;
                        }
                    }
                    self.servcWorkVoucher.servcWorkVoucherStaffs = servcWorkVoucherStaffList;
                    //
                    let postData = self.servcWorkVoucher;
                    let theLoad = MsgBox.loading();
                    servcDelivApi.saveServcWorkVoucher(postData, function (result) {
                        theLoad.close();
                        if(result.type === "info") {
                            self.notityChange();
                            MsgBox.success("新增成功");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    MsgBox.warning("请选择主工程师");
                }
            },
            notityChange: function () {
                let addWork = 1;
                this.$emit("action-chang", addWork)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherAdd.vue